import React, { useEffect, useState } from 'react';
import { Modal, notification, Space, Spin, Upload } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import firebase from 'firebase';

import ReactPanZoom from 'react-image-pan-zoom-rotate';
import { downloadBlob } from '../common-constants';

const ImageUploader = ({ disabledAdd, maxImageSize, storageFolder, fileList, setFileList, multiple }) => {
  const [uploadInProgress, setUploadInProgress] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [localFileList, setLocalFileList] = useState([]);

  const firebaseRef = firebase.storage()
    .ref(window.location.hostname.split('.')[0] + '/' + storageFolder);

  const onPreview = file => {
    if (file && file.url) {
      setPreviewImage(file);
      setPreviewVisible(true);
    }
  };

  useEffect(() => {
    const temp = [...fileList];
    temp.forEach(t => t.status = 'done');
    setLocalFileList(fileList);
  }, [fileList])

  const onChange = (e) => {
    //
  };

  const customUploadRequest = (e) => {
    if (e.file) {
      setUploadInProgress(true);
      firebaseRef.child(e.file.name).put(e.file, { cacheControl: 'public, max-age=86400' })
        .then((snapshot) => {
          snapshot.ref.getDownloadURL().then((downloadURL) => {
            setFileList(prev => [...prev, {
              uid: e.file.uid,
              name: e.file.name,
              url: downloadURL,
            }]);
            setUploadInProgress(false);
          }).catch(error => {
            setUploadInProgress(false);
            notification['error']({
              message: 'Error',
              description:
                'File could not be uploaded.',
            });
          });
        });
    }
  };

  const onRemove = (file) => {
    firebaseRef.child(file.name)
      .delete()
      .then(() => {
        notification['info']({
          message: 'Info',
          description:
            'File deleted.',
        });
      }).catch(error => {
        console.error("File couldn't be deleted", error)
      // notification['error']({
      //   message: 'Error',
      //   description:
      //     'File could not be deleted.',
      // });
    }).finally(() => {
      const tempFileList = [...fileList];
      const filtered = tempFileList
        .filter(f => !(f.uid === file.uid && f.name === file.name));
      setFileList(filtered);
    });
  };

  const onDownload = (image) => {
    fetch(image.url, { method: 'GET', })
      .then((response) => response.blob())
      .then((blob) => downloadBlob(blob, image.name));
  };

  return (
    <div>
      <Upload
        listType="picture-card"
        fileList={localFileList}
        onPreview={onPreview}
        onChange={onChange}
        customRequest={customUploadRequest}
        onRemove={onRemove}
        onDownload={onDownload}
        showDownloadIcon
        multiple={multiple}
        disabled={disabledAdd}
        showUploadList={{
          showPreviewIcon: true,
          showDownloadIcon: true,
          showRemoveIcon: !disabledAdd,
        }}
        accept="image/*"
        maxCount={maxImageSize}
      >
        {!disabledAdd && fileList && fileList.length < maxImageSize && (
          <div>
            <Space direction="vertical">
              <PlusOutlined/>
              <div className="ant-upload-text">Upload</div>
              {uploadInProgress && (
                <div>
                  <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin/>}/>
                </div>)
              }
            </Space>
          </div>
        )}
      </Upload>
      <Modal
        visible={previewVisible}
        footer={previewImage.name}
        onCancel={() => setPreviewVisible(false)}
        closable={false}
        destroyOnClose
        centered
      >
        <ReactPanZoom image={previewImage.url} alt="image"/>
      </Modal>
    </div>
  );
};

export default ImageUploader;
